import { isTouchDevice, desktopMedia } from '../../utilities/device-detection'
import { Logger } from '../../utilities/Logger'
import { documentReady } from '../../utilities/ready'

const logger = new Logger('Drag Scrolling')

class DragScrolling {
  constructor (elem, checkOverflown = true) {
    if (isTouchDevice() && !desktopMedia.matches) {
      elem.style.overflow = 'auto'
      return elem
    }

    this.delta = 6
    this.isDrag = false
    this.elem = elem
    this.pos = { top: 0, left: 0, x: 0, y: 0, startX: 0, startY: 0 }
    this.evRestorer = null
    this.eventsAttached = false

    documentReady().then(() => {
      if (this.isOverflown(elem) || checkOverflown === false) {
        this.elem.addEventListener('mousedown', e => this.mouseDownHandler(e))
        this.elem.addEventListener('click', (e) => this.clickHandler(e), false)
        this.eventsAttached = true
      }
    })
  }

  reinit () {
    if (isTouchDevice() && !desktopMedia.matches) {
      this.elem.style.overflow = 'auto'
      return this.elem
    }

    if (this.isOverflown(this.elem) && !this.eventsAttached) {
      this.elem.addEventListener('onmouseover', e => { document.body.style.cursor = 'grab' })
      this.elem.addEventListener('onmouseout', e => { document.body.style.cursor = 'default' })
      this.elem.addEventListener('mousedown', e => this.mouseDownHandler(e))
      this.elem.addEventListener('click', (e) => this.clickHandler(e), false)
      this.eventsAttached = true
    }
  }

  clickHandler (e) {
    if (this.isDrag) {
      e.preventDefault()
    }
  }

  mouseDownHandler (e) {
    if (e.button === 0) {
      this.elem.style.cursor = 'grabbing'
      this.elem.style.userSelect = 'none'

      this.pos = {
        left: this.elem.scrollLeft,
        top: this.elem.scrollTop,
        // Get the current mouse position
        x: e.clientX,
        y: e.clientY,
        startX: e.pageX,
        startY: e.pageY
      }

      this.mmH = this.mouseMoveHandler.bind(this)
      this.muH = this.mouseUpHandler.bind(this)

      document.addEventListener('mousemove', this.mmH)
      document.addEventListener('mouseup', this.muH)
    }
  }

  mouseMoveHandler (e) {
    // How far the mouse has been moved
    const dx = e.clientX - this.pos.x
    const dy = e.clientY - this.pos.y

    // Scroll the element
    this.elem.scrollTop = this.pos.top - dy
    this.elem.scrollLeft = this.pos.left - dx
  }

  mouseUpHandler (e) {
    if (e.button === 0) {
      const diffX = Math.abs(e.pageX - this.pos.startX)
      const diffY = Math.abs(e.pageY - this.pos.startY)

      if (diffX < this.delta && diffY < this.delta) {
        // This is a click not a drag
        this.isDrag = false
      } else {
        this.isDrag = true
      }
      document.removeEventListener('mousemove', this.mmH)
      document.removeEventListener('mouseup', this.muH)
      this.elem.style.cursor = 'grab'
      this.elem.style.removeProperty('user-select')
    }
  }

  isOverflown (element) {
    const computedStyle = getComputedStyle(element)
    const gap = parseFloat(computedStyle.gap) || 0
    const padding = parseFloat(computedStyle.paddingLeft) + parseFloat(computedStyle.paddingRight)
    let childWidth = 0
    Array.from(element.children).forEach(child => {
      childWidth += (child.offsetWidth + gap)
    })
    return (element.clientWidth - padding) <= childWidth
  }
}

const setupScrolling = function (parent, watch = true) {
  if (watch === true) {
    document.addEventListener('leShuttle:content-change', (e) => {
      setupScrolling(e.target, false)
    })
  }

  const scrollers = parent.querySelectorAll('[data-scroll]')
  logger.log('setting up scrolling')
  return [...scrollers].map(x => new DragScrolling(x))
}

export {
  DragScrolling,
  setupScrolling
}
